import { observable } from 'mobx'
import BaseStore from '@store/table'
import Api from '@api/microLeaflet'
import { getMerchantInfo } from '@util'

class Store extends BaseStore {
  $listApi = Api.getFinderList
  @observable checked = []
  @observable id = ''
  @observable coverModalVisible = false
  @observable list_img = ''
  $extraOp = data => {
    this.total = data.total_count || 0
    this.$list = (data.list || []).map(item => {
      item.checked = false
      return item
    })
  }

  $getParams = () => {
    return {
      ...this.$params,
      merchant_id: getMerchantInfo().id
    }
  }

  toggleItemSelect = (item, indexStore) => {
    this.$list = this.$list.map(i => {
      i.checked = i.id == item.id
      return i
    })

    indexStore.changeSelectActivity(item)
  }
}
export default Store
